import styled from "styled-components";
import { Div } from "../../common/ui/widgets";

export const ChangePasswordWrapper = styled(Div)`
  width: ${(props) => props.theme.width50Percentage};
  background-color: ${(props) => props.theme.greyLight};
  color: ${(props) => props.theme.darkGrey};
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  form {
    padding: ${(props) => props.theme.padding10} ${(props) => props.theme.padding38};
    display: block;
    position: absolute;
    width: ${(props) => props.theme.width310};
    height: auto;
    outline: 0;
    background-color: #ebebeb;
    color: #333333;
    padding-bottom: ${(props) => props.theme.padding30};
    opacity: ${(props) => props.theme.opacity1};
    h5 {
      font-size: ${(props) => props.theme.font20};
      font-weight: ${(props) => props.theme.fontWeight600};
    }
    .error-msg {
      display: flex;
      color: red;
      margin-bottom: ${(props) => props.theme.margin10};
      span {
        margin-right: ${(props) => props.theme.margin5};
        border: 1px solid red;
        border-radius: ${(props) => props.theme.borderRadius50Percentage};
        color: red;
        font-size: ${(props) => props.theme.font9};
        text-align: center;
        font-weight: bold;
        width: ${(props) => props.theme.width19};
        height: ${(props) => props.theme.width19};
        display: flex;
        justify-content: center;
        align-items: center;
      }
      p {
        margin-bottom: ${(props) => props.theme.margin10};
      }
    }
  }
  input,
  select {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background-color: white;
    border: 1px solid #efefef;
    border-radius: 0;
    box-sizing: border-box;
    color: black;
    margin: ${(props) => props.theme.margin10} ${(props) => props.theme.margin0};
    padding: ${(props) => props.theme.padding6} ${(props) => props.theme.padding5};
    width: 100%;
    font-weight: ${(props) => props.theme.fontWeight300};
  }

  label {
    font-size: ${(props) => props.theme.font12};
    font-weight: ${(props) => props.theme.fontWeight400};
    margin-bottom: 0;
    margin-top: ${(props) => props.theme.top5};
  }
  .footer-btn {
    margin-top: ${(props) => props.theme.margin20};
    display: flex;
    justify-content: space-between;
    button {
      padding: ${(props) => props.theme.padding10};
      width: 46%;
      font-weight: ${(props) => props.theme.fontWeight700};
    }
  }
  .footer-btn button:nth-of-type(2) img {
    margin: auto;
    width: 29%;
    height: auto;
    top: 5%;
    left: 36%;
    position: absolute;
  }
`;
